import { c as _c } from "react/compiler-runtime";
import { ProfileActivityLogType } from "@/enums";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import ProfileActivityLogsBannerIcon from "./ProfileActivityLogsBannerIcon";
import ProfileActivityLogsCICRatingIcon from "./ProfileActivityLogsCICRatingIcon";
import ProfileActivityLogsCertificateIcon from "./ProfileActivityLogsCertificateIcon";
import ProfileActivityLogsContactIcon from "./ProfileActivityLogsContactIcon";
import ProfileActivityLogsGeneralCICStatementIcon from "./ProfileActivityLogsGeneralCICStatementIcon";
import ProfileActivityLogsHandleIcon from "./ProfileActivityLogsHandleIcon";
import ProfileActivityLogsNFTAccountStatementIcon from "./ProfileActivityLogsNFTAccountStatementIcon";
import ProfileActivityLogsProfileArchivedIcon from "./ProfileActivityLogsProfileArchivedIcon";
import ProfileActivityLogsProfileImageIcon from "./ProfileActivityLogsProfileImageIcon";
import ProfileActivityLogsProxyActionChangedIcon from "./ProfileActivityLogsProxyActionChangedIcon";
import ProfileActivityLogsProxyActionCreatedIcon from "./ProfileActivityLogsProxyActionCreatedIcon";
import ProfileActivityLogsProxyActionStateChangedIcon from "./ProfileActivityLogsProxyActionStateChangedIcon";
import ProfileActivityLogsProxyCreatedIcon from "./ProfileActivityLogsProxyCreatedIcon";
import ProfileActivityLogsSocialMediaAccountIcon from "./ProfileActivityLogsSocialMediaAccountIcon";
import ProfileActivityLogsSocialMediaVerificationPostIcon from "./ProfileActivityLogsSocialMediaVerificationPostIcon";
export default function ProfileActivityLogsIcon(t0) {
  const $ = _c(17);
  const {
    logType
  } = t0;
  switch (logType) {
    case ProfileActivityLogType.RATING_EDIT:
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsCICRatingIcon />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case ProfileActivityLogType.HANDLE_EDIT:
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsHandleIcon />;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case ProfileActivityLogType.SOCIALS_EDIT:
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsSocialMediaAccountIcon />;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case ProfileActivityLogType.CONTACTS_EDIT:
      {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsContactIcon />;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case ProfileActivityLogType.SOCIAL_VERIFICATION_POST_EDIT:
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsSocialMediaVerificationPostIcon />;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
    case ProfileActivityLogType.CLASSIFICATION_EDIT:
      {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsCertificateIcon />;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case ProfileActivityLogType.BANNER_1_EDIT:
      {
        let t1;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsBannerIcon />;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
    case ProfileActivityLogType.BANNER_2_EDIT:
      {
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsBannerIcon />;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case ProfileActivityLogType.PFP_EDIT:
      {
        let t1;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsProfileImageIcon />;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
    case ProfileActivityLogType.PROFILE_ARCHIVED:
      {
        let t1;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsProfileArchivedIcon />;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    case ProfileActivityLogType.GENERAL_CIC_STATEMENT_EDIT:
      {
        let t1;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsGeneralCICStatementIcon />;
          $[10] = t1;
        } else {
          t1 = $[10];
        }
        return t1;
      }
    case ProfileActivityLogType.NFT_ACCOUNTS_EDIT:
      {
        let t1;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsNFTAccountStatementIcon />;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    case ProfileActivityLogType.PROXY_CREATED:
      {
        let t1;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsProxyCreatedIcon />;
          $[12] = t1;
        } else {
          t1 = $[12];
        }
        return t1;
      }
    case ProfileActivityLogType.PROXY_ACTION_CREATED:
      {
        let t1;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsProxyActionCreatedIcon />;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
    case ProfileActivityLogType.PROXY_ACTION_STATE_CHANGED:
      {
        let t1;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsProxyActionStateChangedIcon />;
          $[14] = t1;
        } else {
          t1 = $[14];
        }
        return t1;
      }
    case ProfileActivityLogType.PROXY_ACTION_CHANGED:
      {
        let t1;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ProfileActivityLogsProxyActionChangedIcon />;
          $[15] = t1;
        } else {
          t1 = $[15];
        }
        return t1;
      }
    case ProfileActivityLogType.DROP_COMMENT:
    case ProfileActivityLogType.DROP_RATING_EDIT:
    case ProfileActivityLogType.DROP_CREATED:
    case ProfileActivityLogType.PROXY_DROP_RATING_EDIT:
      {
        let t1;
        if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <></>;
          $[16] = t1;
        } else {
          t1 = $[16];
        }
        return t1;
      }
    default:
      {
        assertUnreachable(logType);
      }
  }
}